module.exports = __webpack_public_path__ + "img/5.181f6db7.png";